var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOlhoFechado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Olho Fechado",
    clipPath: "url(#clip0_89_313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.95 15.45C13.5255 16.5358 11.791 17.1374 10 17.1667C4.16671 17.1667 0.833374 10.5 0.833374 10.5C1.86995 8.56825 3.30765 6.88051 5.05004 5.55M8.25004 4.03333C8.82365 3.89907 9.41093 3.83195 10 3.83333C15.8334 3.83333 19.1667 10.5 19.1667 10.5C18.6609 11.4463 18.0576 12.3373 17.3667 13.1583M11.7667 12.2667C11.5378 12.5123 11.2618 12.7093 10.9552 12.8459C10.6485 12.9826 10.3175 13.056 9.98178 13.062C9.64611 13.0679 9.31268 13.0061 9.00138 12.8804C8.69009 12.7547 8.40731 12.5675 8.16991 12.3301C7.93252 12.0927 7.74537 11.81 7.61963 11.4987C7.49389 11.1874 7.43215 10.8539 7.43807 10.5183C7.44399 10.1826 7.51746 9.85154 7.6541 9.54487C7.79074 9.23821 7.98775 8.96221 8.23337 8.73333",
    stroke: "#979DAC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.833374 1.33331L19.1667 19.6666",
    stroke: "#979DAC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlhoFechado);
export default __webpack_public_path__ + "static/media/Olho Fechado.2d42a8df889e355aaad4a504b7a1c370.svg";
export { ForwardRef as ReactComponent };